module.exports =
{
	API_SERVER_URL:					process.env.API_SERVER_URL					|| 'https://bitbybit-app-backend.herokuapp.com/',
	CONTACT_EMAIL:					process.env.CONTACT_EMAIL 					|| 'contact@bitbybit.software',
	CONTACT_SUBJECT:				process.env.CONTACT_SUBJECT					|| 'Bit By Bit - Contact Form',
	SITE_NAME:						process.env.SITE_NAME 						|| 'Bit By Bit Software'
}
